import Vue from "vue";
import { createAssetEntry, deleteAssetEntry } from "@/data/models/asset.model";
import { Image } from "@/components/blocks/image/image.class";
import { bus } from "@/main";

// import { upload } from './file-upload.service';

const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3;

export default {
	name: 'FileBlock',
	data() {
		return {
			uploadedFiles: [],
			uploadError: null,
			currentStatus: null,
			uploadFieldName: 'photos',
			// images: [],
			deleteModal: null,
		}
	},
	props: [
		"message",
		"files",
		"limit",
		"projectId"
	],
	created() {
		console.log("Files: ", this.files)
	},
	watch: {
	},
	computed: {
		isInitial() {
			return this.currentStatus === STATUS_INITIAL;
		},
		isSaving() {
			return this.currentStatus === STATUS_SAVING;
		},
		isSuccess() {
			return this.currentStatus === STATUS_SUCCESS;
		},
		isFailed() {
			return this.currentStatus === STATUS_FAILED;
		},
		getFiles() {
			return this.files;
		}
	},
	methods: {
		reset() {
			// reset form to initial state
			this.currentStatus = STATUS_INITIAL;
			this.uploadedFiles = [];
			this.uploadError = null;
		},
		save(fileFormData) {
			// upload data to the server
			this.currentStatus = STATUS_SAVING;

			console.log("FileBlock :: save() :: going to save file", fileFormData.get("file"))

			createAssetEntry(fileFormData)
				.then(x => {
					// console.log("File:", x)
					this.uploadedFiles = [].concat(x);
					this.currentStatus = STATUS_SUCCESS;
					let fileContent = new Image(x.data)
					this.files.push(fileContent)
					if(this.message) {
						let content = { images: this.files, id: this.projectId }
						bus.$emit(this.message, content)
					}
				})
				.catch(err => {
					this.uploadError = err.response;
					this.currentStatus = STATUS_FAILED;
				});

		},
		filesChange(fieldName, fileList) {

			// Null check
			if (!fileList.length) {
				return;
			}

			Array
				.from(Array(fileList.length).keys())
				.forEach(n => {
					const file = fileList[n];
					const formDataFile = new FormData()
					formDataFile.append("name", file.name);
					formDataFile.append("action", "upload-attachment");
					formDataFile.append("file", file);
					this.save(formDataFile);
				});
		},
		deleteFile(file) {
			console.log("🗑 file DELETE :", file);
			console.log("💪 Project ID:", this.projectId);
			deleteAssetEntry(file.id)
				.then(x => {
					// console.log("Delete Response:", x)
					this.uploadedFiles = [].concat(x);
					this.currentStatus = STATUS_SUCCESS;
					if( x.status == 200 ) {
						let index = this.files.indexOf(file);
						this.files.splice(index, 1)
						let content = { images: this.files, id: this.projectId }
						bus.$emit("deleteImage", content );
					}
				})
			.catch(err => {
				this.uploadError = err.response;
				this.currentStatus = STATUS_FAILED;
			});
		}
	},
	mounted() {
		this.reset();
	},

}



// WEBPACK FOOTER //
// ./src/components/blocks/file-block/file.block.js